var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconMultipleUsers3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 16.875a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0Zm6.849 6.375a4.474 4.474 0 0 0-8.448 0M2.349 3.375a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0ZM9.2 9.75a4.474 4.474 0 0 0-8.449 0Zm7.201-6.375a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0ZM23.25 9.75a4.474 4.474 0 0 0-8.449 0Zm-19.5 3v3.75A2.25 2.25 0 0 0 6 18.75h.75m13.5-6v3.75A2.25 2.25 0 0 1 18 18.75h-.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconMultipleUsers3);
export default __webpack_public_path__ + "static/media/streamline-icon-multiple-users-3.db008793.svg";
export { ForwardRef as ReactComponent };